module.exports = __webpack_public_path__ + "media/images/flags/km-18fb13911403c5195cc696c4abd5a4a0.svg";